const mutations = {
  SET_MARKETS (state, { markets }) {
    state.markets = markets
  }
}

export default mutations
